<template>
    <div>
        <b-container :class="{'container-cover': coverPage }">
            <b-form @submit.prevent="onNextClick">
                <div class="row wrapper-step-content" v-if="!coverPage">
                    <div class="col-12 step-content">
                        <b-row class="row-navbar-padding" v-if="$route.meta.showNavigation"/>
                        <div class="wrapper-step-content__form">
                            <slot/>
                        </div>
                    </div>
                </div>
                <div class="step-content-cover" v-else>
                    <slot/>
                </div>
                <b-row class="mb-4" :class="{ 'button-row': !coverPage}">
                    <b-col cols="6" md="3" offset-md="6" class="text-center">
                        <b-button :class="[isJACareerEntrepreApp ? 'button-light' : '']" block variant="light" size="lg" @click="onPrevClick">
                            {{ prevName }}
                        </b-button>
                    </b-col>
                    <b-col cols="6" md="3" class="pr-0 button-next">
                        <b-button :class="[isJACareerEntrepreApp ? 'button-green' : '']" block variant="primary" size="lg" :disabled="nextDisabled" type="submit"
                                  :aria-label="nextName">
                            {{ nextName }}
                            <img v-if="nextDisabled"
                                 class="next-arrow" src="../Images/next_arrow_gray.svg" alt="next" height="35"
                                 width="35">
                            <img v-else
                                 class="next-arrow" src="../Images/next_arrow.svg" alt="next" height="35" width="35">
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-container>
    </div>
</template>

<script>
    import ModalConflictSync from "./ModalConflictSync";

    export default {
        name: "ProjectStepContainer",
        components: {ModalConflictSync},
        mounted() {
            this.$eventHub.$on('discard-project', (response) => {
                if (this.onDiscardProject) {
                    this.onDiscardProject.apply(this, {...response})
                }
            });

            this.$eventHub.$on('keep-version-project', (response) => {
                if (this.onKeepVersionProject) {
                    this.onKeepVersionProject.apply(this, {...response})
                }
            });
        },
        props: {
            prevName: {
                type: String,
                default: 'Previous'
            },
            onDiscardProject: {
                type: Function
            },
            onKeepVersionProject: {
                type: Function
            },
            nextName: {
                type: String,
                default: 'Next'
            },
            prevTo: {
                type: String
            },
            nextTo: {
                type: String
            },
            nextDisabled: {
                type: Boolean,
                default: false
            },
            coverPage: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onNextClick(e) {
                if (this.nextTo) {
                    const index = this.$route.params.index
                    this.$router.push({name: this.nextTo, params: {index}})
                }
                this.$emit('next-click', e)
            },
            onPrevClick(e) {
                if (this.prevTo) {
                    const index = this.$route.params.index
                    this.$router.push({name: this.prevTo, params: {index}})
                }
                this.$emit('prev-click', e)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    +for_breakpoint(md)
        .container
            margin-top 75px
            &-cover
                display block
                margin-top 0
    .wrapper-step-content
        background-color white
        min-height calc(100vh - 142px)
        padding-top 22px
        &__form
            display flex
            flex-direction column

    +for_breakpoint(xs sm md)
        .wrapper-step-content
            &__form
                padding 10px 10px

    .row-navbar-padding
        padding-top 75px

    .button-row
        padding-top 19px
        padding-bottom 28px

    .next-arrow
        margin-left 5px

    .step-content-cover
        min-height calc(100vh - 72px)
        overflow-wrap: anywhere;

    .button-row-cover
        margin-top -20px
        padding-bottom 28px

    .button-green
        background-color color-green-light
        &:hover
            background-color color-green-dark
        &.disabled
            background-color color-7
            color color-17

    .button-light
        color color-green-light
        &:hover
        &:not(:disabled):not(.disabled):active:focus
        &:not(:disabled):not(.disabled):active
            color color-green-dark
            box-shadow none !important

    @media (max-width: 375px)
        .font-size
            .row-navbar-padding
                padding-top 125px !important

    @media (min-width: 767px)
        .wrapper-step-content
            border-radius 27px
            box-shadow(0px 4px 5px 0px #BDD5E580)
            min-height calc(100vh - 217px)
            padding-bottom 20px

        .row-navbar-padding
            padding-top 18px

        .button-next
            padding-right: 15px !important

    @media (min-width: 991px)
        .wrapper-step-content
            margin-top 15px

    +for_breakpoint(xs sm md)
        .button-next
            button
                border-radius 5px 0 0 5px

</style>
